export default "__VITE_ASSET__DMRbeAP1__"